<section class="more-learning-prgs">
  <div class="title text-center" i18n="home programs: title">More Learning <span class="position-relative"
      style="font-family: 'Poppins Bold';">Programmes<img class="position-absolute" style="left: 0;
      bottom: -14px;
      width: 100%;" src="./assets/lines/2.png" alt=""></span></div>
  <div class="d-flex inner mx-auto">
    <div class="prog-box">
      <div class="box-inner d-flex justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: pre-school">Pre School Education</div>
          <div class="desc" i18n="home programs: pre-school desc">Our early childhood learning content includes Math,
            Science, Interactive Storytelling, Arts and Crafts, Music, and more to foster cognitive, emotional, social,
            and physical growth. </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/pre-school']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog1"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: primary-and-secondary-education">Primary & Secondary Education</div>
          <div class="desc" i18n="home programs: primary-and-secondary-education desc">Our courses cover foundational
            school subjects from grades 1 – 13, including Maths, Science, English, IT providing an enriching
            educational experience that aligns with the needs of today's learners. </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/primary-and-secondary-education']" i18n>Learn
            More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog2"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: information-technology">Information Technology</div>
          <div class="desc" i18n="home programs: information-technology desc">Comprehensive IT courses that
            align with the dynamic demands of today's tech-driven world.</div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/information-technology']" i18n>Learn
            More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog3"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: tvet-education">TVET Education</div>
          <div class="desc" i18n="home programs: tvet-education desc">Specifically targeting NVQ levels 3 and 4 skill
            development.</div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/tvet-education']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog4"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: languages">Languages</div>
          <div class="desc" i18n="home programs: languages desc">Whether you are a complete beginner, an intermediate
            learner, or seeking advanced fluency, our language courses are tailored to meet your individual needs and
            aspirations. </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/languages']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog5"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: buddhist-studies">Buddhist Studies</div>
          <div class="desc" i18n="home programs: buddhist-studies desc">Offers a comprehensive and thoughtful
            exploration into the rich tapestry of Buddhist thought and practice.</div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/buddhist-studies']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog6"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start gap-5">
        <div class="w-100">
          <div class="title" i18n="home programs: computer-programming">Computer Science</div>
          <div class="desc" i18n="home programs: computer-programming desc">Start your computer science adventure with
            DP Education by learning Coding, Python Programming, Full
            Stack Web development and more, and witness how the power of programming can transform not just
            screens, but lives.</div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/computer-programming']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog7"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: olympiad-and-informatics">Olympiad Maths & Informatics</div>
          <div class="desc" i18n="home programs: olympiad-and-informatics desc">Designed to guide aspiring young minds
            on their path to academic success and recognition at International Olympiads competitions.</div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/olympiad-and-informatics']" i18n>Learn
            More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog8"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: economics">Economics</div>
          <div class="desc" i18n="home programs: economics desc">Meticulously, designed to deepen your subject knowledge
            and comprehension of economics, fostering a
            richer understanding.
          </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/economics']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog9"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: health">Health Education</div>
          <div class="desc" i18n="home programs: health desc">Our expertly curated content is designed to provide a
            holistic view of health, encouraging learners to make informed decisions that promote their well-being.
          </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/health']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog10"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: life-skills">Life Skills</div>
          <div class="desc" i18n="home programs: life-skills desc">Designed to empower learners with the essential
            skills needed to navigate through life successfully.
          </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/life-skills']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog11"></app-brand-slider>
        </div>
      </div>
    </div>
    <div class="prog-box">
      <div class="box-inner d-flex align-items-center justify-content-start">
        <div class="w-100">
          <div class="title" i18n="home programs: sports">Sports</div>
          <div class="desc" i18n="home programs: sports desc">Elevate your performance in Cricket and Track and Field
            through our premier training programs. Join us to be coached by champions who've clinched World Cups and
            Olympic triumphs, ensuring you learn from the best in the game.
          </div>
          <button class="btn btn-learn-more" [routerLink]="['/programs/sports']" i18n>Learn More</button>
        </div>
        <div class="programs">
          <app-brand-slider [brands]="prog12"></app-brand-slider>
        </div>
      </div>
    </div>
  </div>
</section>